import { MenuItemAggregate } from '../../../../../aggregats/menu/menu-item.aggregate';
import { evaluationsModelesSousMenuItem, modelesSousMenuItem, suiviAutomatisationsSousMenuItem, suiviDocumentsSousMenuItem } from './sous-menu-items.constantes';

export const communicationMenuItem: MenuItemAggregate = new MenuItemAggregate('icon-message-square', 'Communication', [
  suiviDocumentsSousMenuItem,
  suiviAutomatisationsSousMenuItem,
  modelesSousMenuItem,
  evaluationsModelesSousMenuItem
]);
